import { Component } from 'react';
import ConsoleHelper from './ConsoleHelper.js';
import authHeaders from './authHeaders.js';

class MyResource extends Component {
  static fnLanguageValues(type) {
    var value = ""
    try {
      //var currentPageTabId = MyResource.defineTabID();
      //var lang_details = JSON.parse(localStorage.getItem('lang_details' + currentPageTabId));
      var lang_details = JSON.parse(localStorage.getItem('lang_details'));
      value = lang_details[type];
    }
    catch (Ex) {
      value = "";
    }
    return value;
  }

  static lngUpdated = false;


  static defineTabID = () => {
    var pageTabId = sessionStorage.getItem("tabID");
    ConsoleHelper("pageTabId first" + pageTabId)

    // if it is the first time that this page is loaded
    if (pageTabId == null) {
      ConsoleHelper("inside def tab...")
      var localTabId = localStorage.getItem("tabID");
      // if tabID is not yet defined in localStorage it is initialized to 1
      // else tabId counter is increment by 1
      pageTabId = (localTabId == null) ? 1 : Number(localTabId) + 1;
      // new computed value are saved in localStorage and in sessionStorage
      localStorage.setItem("tabID", pageTabId);
      sessionStorage.setItem("tabID", pageTabId);
    }
    ConsoleHelper("pageTabId" + pageTabId);
    //this.setState({ currentPageTabId: pageTabId });
    return pageTabId;

  }

  static fnUpdateLanguageValues(lang) {
    //var currentPageTabId = this.defineTabID();
    fetch(process.env.REACT_APP_URL + "/fm_language_label?lng_code=" + lang, { headers: authHeaders() })
      .then(res => res.json())
      .then(details => {
        var temp_details = {};
        for (var i in details) {
          temp_details[details[i].label_code] = details[i].label_text
        }
        //localStorage.setItem('lang_details' + currentPageTabId, JSON.stringify(temp_details));
        localStorage.setItem('lang_details', JSON.stringify(temp_details));
        this.lngUpdated = true;
      },
        (error) => { this.setState({ IsError: true }) })
      .catch(error => { ConsoleHelper(error) });
  }
}
export default (MyResource);
